import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminListServices, adminDeleteService } from "@/lib/api";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { toast } from "sonner";

export default function AdminServices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); adminListServices().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);

  const remove = async (id, name) => {
    if (!window.confirm(`Delete "${name}"?`)) return;
    await adminDeleteService(id);
    toast("Service deleted", { description: name });
    load();
  };

  return (
    <div>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="font-serif-latin text-3xl text-ink">Services</h1>
          <p className="mt-1 text-sm text-ink-3">Pooja & Yagya offerings ({items.length})</p>
        </div>
        <Link to="/admin/services/new" data-testid="admin-new-service" className="inline-flex items-center gap-2 bg-[var(--saffron)] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[var(--saffron-dark)]">
          <Plus className="h-4 w-4" /> New Service
        </Link>
      </div>
      {loading ? <p className="py-16 text-center text-ink-3">…</p> : (
        <div className="overflow-hidden border border-line bg-surface">
          <table className="w-full text-left text-sm">
            <thead className="border-b border-line bg-surface-alt/50 text-xs uppercase tracking-wider text-ink-3">
              <tr><th className="px-4 py-3">Name</th><th className="px-4 py-3">Kind</th><th className="hidden px-4 py-3 sm:table-cell">Deity</th><th className="px-4 py-3 text-right">Actions</th></tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} data-testid={`admin-service-row-${s.slug}`} className="border-b border-line last:border-0">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">{s.featured && <Star className="h-3.5 w-3.5 fill-[var(--gold)] text-[var(--gold)]" />}<span className="font-deva-body text-ink">{s.devanagari_name || s.name}</span></div>
                    <span className="text-xs text-ink-3">{s.name}</span>
                  </td>
                  <td className="px-4 py-3 capitalize text-ink-2">{s.kind}</td>
                  <td className="hidden px-4 py-3 text-ink-2 sm:table-cell">{s.deity}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-end gap-2">
                      <Link to={`/admin/services/${s.id}`} className="p-2 text-ink-2 hover:text-saffron"><Pencil className="h-4 w-4" /></Link>
                      <button onClick={() => remove(s.id, s.name)} className="p-2 text-ink-2 hover:text-[var(--saffron-dark)]"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
